<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__umeng-config">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.title" placeholder="标题" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.yum" placeholder="对应域名" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.status" placeholder="状态" clearable>
            <el-option label="开启" :value="1"></el-option>
            <el-option label="关闭" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="id" label="ID" header-align="center" align="center" width="80"></el-table-column>
        <el-table-column prop="title" label="标题" header-align="center" align="center"></el-table-column>
        <el-table-column prop="yum" label="对应域名" header-align="center" align="center" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            {{ formatYumArray(scope.row.yum) }}
          </template>
        </el-table-column>
        <el-table-column prop="content" label="内容" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="status" label="状态" header-align="center" align="center" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === 1" type="success">开启</el-tag>
            <el-tag v-else type="danger">关闭</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createDate" label="创建时间" header-align="center" align="center" width="180"></el-table-column>
        <el-table-column prop="updateDate" label="更新时间" header-align="center" align="center" width="180"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="220">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status === 0" type="text" size="small" @click="toggleStatus(scope.row, 1)" style="color: #67C23A;">开启</el-button>
            <el-button v-if="scope.row.status === 1" type="text" size="small" @click="toggleStatus(scope.row, 0)" style="color: #F56C6C;">关闭</el-button>
            <el-button v-if="$hasPermission('content:content:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('content:content:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="refreshDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './umeng-config-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/content/content/page',
        getDataListIsPage: true,
        deleteURL: '/content/content',
        deleteIsBatch: true
      },
      dataForm: {
        id: '',
        title: '',
        content: '',
        yum: '',
        status: ''
      }
    }
  },
  methods: {
    // 格式化 yum 数组为字符串
    formatYumArray(yum) {
      if (!yum) {
        return '-'
      }
      // 如果是数组，用逗号分隔
      if (Array.isArray(yum)) {
        return yum.join(', ')
      }
      // 如果是字符串（可能是JSON格式），尝试解析
      if (typeof yum === 'string') {
        try {
          const parsed = JSON.parse(yum)
          if (Array.isArray(parsed)) {
            return parsed.join(', ')
          }
          return yum
        } catch (e) {
          return yum
        }
      }
      return yum
    },

    // 重写新增/修改方法，直接传递整行数据
    addOrUpdateHandle (row) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(row)
      })
    },
    // 切换状态
    toggleStatus (row, status) {
      const statusText = status === 1 ? '开启' : '关闭'
      this.$confirm(`确定要${statusText}该配置吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 使用修改接口，保持其他字段不变，只修改状态
        const updateData = {
          id: row.id,
          title: row.title,
          content: row.content,
          yum: row.yum,  // 包含 yum 字段
          status: status
        }
        this.$http.put('/content/content', updateData).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message.success(`${statusText}成功`)
          this.getDataList()
        }).catch(() => {
          this.$message.error(`${statusText}失败`)
        })
      }).catch(() => {})
    }
  },
  components: {
    AddOrUpdate
  }
}
</script>
